export default "__VITE_ASSET__ClAhBv2R__"